var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 121,
    viewBox: "0 0 138 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.322 63.8617L128.756 84.9296L120.162 105.675L85.3017 120.393L15.2083 91.9054L0.458527 56.9561L9.02424 35.8881L17.6187 15.1427L52.4786 0.424805L122.572 28.9123L137.322 63.8617Z",
    fill: "url(#paint0_linear_3288_1595)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.108 64.0405L105.402 75.6264L100.798 86.9634L85.1321 93.5784L63.1128 84.6232L42.329 76.182L34.1176 72.8425L33.1567 70.5662L30.2227 63.6191L27.4611 57.0775L36.8984 34.2887L52.657 27.6322L103.068 48.1254L103.384 48.2531L103.458 48.2819L106.293 55.0023L109.223 61.9462L110.108 64.0405Z",
    fill: "url(#paint1_linear_3288_1595)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6602 27.6322L52.4782 0.424896L122.568 28.9124L103.458 48.2787L52.6602 27.6322Z",
    fill: "url(#paint2_linear_3288_1595)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1352 93.5784L85.3746 120.425L15.2844 91.9374L34.1175 72.8425L85.1352 93.5784Z",
    fill: "url(#paint3_linear_3288_1595)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4644 57.0775L0.458221 56.9561L15.2846 91.9374L34.1177 72.8425L27.4644 57.0775Z",
    fill: "url(#paint4_linear_3288_1595)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8985 34.2856L17.6184 15.1427L52.4783 0.424896L52.6603 27.6322L36.8985 34.2856Z",
    fill: "url(#paint5_linear_3288_1595)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.458221 56.9561L17.6184 15.1427L36.8985 34.2855L27.4644 57.0774L0.458221 56.9561Z",
    fill: "url(#paint6_linear_3288_1595)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.894 86.9218L120.324 105.675L85.3014 120.393L85.129 93.5752L100.894 86.9218Z",
    fill: "url(#paint7_linear_3288_1595)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.034 64.0117L137.322 63.8617L122.495 28.8804L103.381 48.2499L110.034 64.0117Z",
    fill: "url(#paint8_linear_3288_1595)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.324 105.675L137.322 63.8617L110.035 64.0118L100.894 86.9218L120.324 105.675Z",
    fill: "url(#paint9_linear_3288_1595)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1304 72.8425C34.1304 72.8425 6.75707 78.8669 4.95964 56.9689H0.470856L15.2941 91.9374L34.1304 72.8425Z",
    fill: "url(#paint10_linear_3288_1595)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94701 56.9689C4.94701 56.9689 11.4727 26.4637 36.8985 34.3015L17.6184 15.1459L0.458221 56.9689H4.94701Z",
    fill: "url(#paint11_linear_3288_1595)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8985 34.2887C36.8985 34.2887 28.4604 14.2488 52.4432 3.73881L52.4783 0.424896L17.6184 15.1427L36.8985 34.2887Z",
    fill: "url(#paint12_linear_3288_1595)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7017 26.7159C52.7017 26.7159 68.1858 8.36169 122.495 28.8805L52.4782 0.424896L52.7017 26.7159Z",
    fill: "url(#paint13_linear_3288_1595)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6411 70.2501L106.283 54.9959L103.448 48.2915L103.375 48.2627L103.055 48.135L52.6474 27.6322L36.8887 34.2887L27.4514 57.0775L32.732 69.5861L33.147 70.5662L34.1048 72.8425C34.2234 71.967 34.4026 71.1008 34.6411 70.2501ZM102.963 48.151L38.2073 61.9206C44.6914 51.251 61.2323 37.9953 102.95 48.151H102.963Z",
    fill: "url(#paint14_linear_3288_1595)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.224 61.9461L42.3297 76.1818L63.1135 84.6231L105.403 75.6263L110.108 64.0404L109.224 61.9461Z",
    fill: "url(#paint15_linear_3288_1595)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1304 72.8425C34.1304 72.8425 35.7267 99.7752 85.3141 120.393L15.2941 91.9374L34.1304 72.8425Z",
    fill: "url(#paint16_linear_3288_1595)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.298 47.7454C94.9367 43.9941 77.2274 36.5394 56.0733 27.8939C55.3629 27.6029 54.7535 27.11 54.3205 26.4761C53.8875 25.8422 53.65 25.0953 53.6373 24.3278C53.532 17.9426 53.3787 12.3492 53.1936 8.19239C52.9829 3.33646 52.7306 0.421615 52.4784 0.424807C52.2262 0.428 52.0155 3.34283 51.8654 8.20196C51.7409 12.3523 51.6579 17.9426 51.6388 24.3373C51.6371 25.1059 51.4095 25.857 50.9843 26.4973C50.5592 27.1376 49.9552 27.6388 49.2475 27.9386L39.1589 32.2103C38.5469 32.4688 37.8722 32.5412 37.2193 32.4186C36.5663 32.296 35.9639 31.9836 35.4874 31.5207C30.7305 26.9042 26.5897 22.9613 23.4992 20.104C19.9555 16.8316 17.7813 14.9766 17.6185 15.1427C17.4557 15.3087 19.3233 17.4669 22.6213 20.9883C25.4946 24.0596 29.4758 28.1748 34.1146 32.9031C34.5812 33.3751 34.8982 33.9743 35.026 34.6257C35.1538 35.277 35.0866 35.9516 34.8329 36.565C33.1728 40.5908 29.546 49.3673 27.6879 53.8784C27.4192 54.5348 26.9625 55.0972 26.3751 55.4948C25.7878 55.8924 25.096 56.1076 24.3868 56.1132C17.8515 56.1579 12.223 56.2505 8.06942 56.3846C3.28052 56.5378 0.448691 56.739 0.445498 56.9688C0.442306 57.1987 3.27413 57.4286 8.06302 57.6265C12.2677 57.7957 17.9888 57.9458 24.6326 58.0479C25.3254 58.0586 26.0005 58.2683 26.5773 58.6521C27.1542 59.036 27.6084 59.5776 27.8859 60.2125C30.0377 65.1259 31.9213 69.3657 33.4537 72.7466C29.5013 76.98 27.292 79.4798 27.4325 79.6203C27.573 79.7608 34.7691 72.9829 34.7691 72.9829C34.7691 72.9829 32.0426 66.1092 29.6929 60.2955C28.9114 58.3579 28.9229 56.1908 29.7248 54.2615C31.5541 49.8621 34.5967 42.5256 36.3494 38.2986C37.2064 36.2306 38.8447 34.5843 40.9084 33.7172L49.8477 29.9563C51.6573 29.196 53.694 29.1811 55.5146 29.9148C77.5084 38.7774 103.509 48.7511 103.509 48.7511C103.509 48.7511 107.34 44.4539 107.247 44.3453C107.155 44.2368 105.731 45.4627 103.298 47.7454Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.3014 120.393L120.324 105.675L137.322 63.8617L122.495 28.8804L135.157 64.2161L118.722 104.127L85.3014 120.393Z",
    fill: "url(#paint17_linear_3288_1595)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1147 9.88135C37.6901 8.80225 35.2414 8.74798 32.6873 9.76003C30.1332 10.7721 28.3582 12.4705 28.7828 13.5528C29.2074 14.6351 31.6561 14.6862 34.2102 13.6742C36.7643 12.6621 38.5393 10.9636 38.1147 9.88135Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7232 33.6885C53.1773 32.2934 50.0326 32.2231 46.6995 33.5289C43.3664 34.8347 41.1125 37.0408 41.6584 38.4231C42.2043 39.8055 45.3522 39.8885 48.6821 38.5796C52.012 37.2706 54.2723 35.0805 53.7232 33.6885Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1273 13.9806C23.8502 14.4883 22.9627 15.3343 23.1766 15.877C23.3905 16.4198 24.6069 16.4421 25.8967 15.9377C27.1865 15.4332 28.0613 14.5808 27.8506 14.0413C27.6399 13.5017 26.4203 13.473 25.1273 13.9806Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3288_1595",
    x1: 121.415,
    y1: 110.326,
    x2: 18.9257,
    y2: 17.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#046603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D70A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3288_1595",
    x1: 131.13,
    y1: 86.6458,
    x2: 9.32769,
    y2: 35.6827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2EB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42CA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3288_1595",
    x1: 144.83,
    y1: 79.9929,
    x2: 41.1413,
    y2: -10.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3288_1595",
    x1: 95.2975,
    y1: 135.304,
    x2: -7.03432,
    y2: 44.3808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#046603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42CA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3288_1595",
    x1: 91.4528,
    y1: 140.483,
    x2: -10.5731,
    y2: 47.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3288_1595",
    x1: 131.847,
    y1: 97.4277,
    x2: 27.4845,
    y2: 3.96983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE04D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3288_1595",
    x1: 105.373,
    y1: 124.214,
    x2: 2.40591,
    y2: 32.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45BF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EDA31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3288_1595",
    x1: 111.396,
    y1: 122.829,
    x2: 7.33629,
    y2: 27.7902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BE114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3288_1595",
    x1: 148.31,
    y1: 77.3365,
    x2: 45.8677,
    y2: -14.8862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42CA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3288_1595",
    x1: 136.965,
    y1: 94.6125,
    x2: 36.2427,
    y2: 0.597819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#046603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42CA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3288_1595",
    x1: 89.26,
    y1: 139.309,
    x2: -12.5211,
    y2: 49.5751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0C22F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3288_1595",
    x1: 102.75,
    y1: 120.836,
    x2: 2.47894,
    y2: 30.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#88DF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4DB36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3288_1595",
    x1: 129.957,
    y1: 93.3567,
    x2: 28.2201,
    y2: 2.6786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3288_1595",
    x1: 144.276,
    y1: 77.086,
    x2: 41.3826,
    y2: -12.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85EB1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6FF75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3288_1595",
    x1: 120.019,
    y1: 105.711,
    x2: 17.932,
    y2: 15.7482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3288_1595",
    x1: 118.858,
    y1: 107.03,
    x2: 16.7712,
    y2: 17.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3288_1595",
    x1: 89.908,
    y1: 139.464,
    x2: -12.4059,
    y2: 49.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#046603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#289E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3288_1595",
    x1: 98.1589,
    y1: 125.605,
    x2: 134.624,
    y2: 32.7414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#67CD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F461"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.6957247debf4a13aefed252300cb2a13.svg";
export { ForwardRef as ReactComponent };